"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var formatRelative_1 = __importDefault(require("date-fns/formatRelative"));
var orderBy_1 = __importDefault(require("lodash/orderBy"));
var Tooltip_1 = __importDefault(require("atomicComponents/atoms/Tooltip"));
var DoubleCell_1 = __importDefault(require("containers/TableMaker/components/DoubleCell"));
var dateTime_1 = require("utils/dateTime");
var Connection = function (_a) {
    var _b, _c;
    var item = _a.item;
    var connections = (0, orderBy_1.default)((_b = item.connectionIds) === null || _b === void 0 ? void 0 : _b.map(function (iCId) { var _a; return (_a = item.connectionsData) === null || _a === void 0 ? void 0 : _a[iCId]; }).filter(end2end_1.notFalsy), function (iC) { var _a, _b; return (_b = (_a = iC.lastSync) === null || _a === void 0 ? void 0 : _a.toMillis()) !== null && _b !== void 0 ? _b : 0; }, 'desc');
    var activeConnections = connections.filter(function (iC) { return iC.status === 'Active'; });
    var inactiveConnections = connections.filter(function (iC) { return iC.status === 'Inactive'; });
    var firstInactiveConnection = inactiveConnections[0];
    return ((0, jsx_runtime_1.jsx)(DoubleCell_1.default, { main: ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (activeConnections.length > 0 && "Active (".concat(activeConnections.length, ")"))
                || (inactiveConnections.length > 0 && "Inactive (".concat(inactiveConnections.length, ")"))
                || 'No connections' })), secondary: activeConnections.length === 0 && firstInactiveConnection && (firstInactiveConnection.lastSync
            ? ((0, jsx_runtime_1.jsx)(Tooltip_1.default, __assign({ arrow: true, title: "Synced last ".concat((0, formatRelative_1.default)(firstInactiveConnection.lastSync.toDate(), new Date())) }, { children: (0, jsx_runtime_1.jsxs)("span", { children: ["Last sync ", (0, dateTime_1.getIntervalDates)((_c = firstInactiveConnection.lastSync) === null || _c === void 0 ? void 0 : _c.toDate(), new Date()), " ago"] }) })))
            : 'Never connected') }));
};
exports.default = Connection;
